import { render, staticRenderFns } from "./ccLive.vue?vue&type=template&id=92a0cf40&scoped=true"
import script from "./ccLive.vue?vue&type=script&lang=js"
export * from "./ccLive.vue?vue&type=script&lang=js"
import style0 from "./ccLive.vue?vue&type=style&index=0&id=92a0cf40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a0cf40",
  null
  
)

export default component.exports